/// <reference path="registerPaymentSectionBase.ts" />
module Meevo.Plugins.Register {
    "use strict";

    export class RegisterCreditPaymentSectionBase extends Meevo.Plugins.Register.RegisterPaymentSectionBase {
        payment: Model.SaleCreditCardPayment;
        showAddPaymentButton: boolean = false;

        get $translate() { return this.registerContext.$translate; }
        get $filter() { return this.registerContext.$filter; }
        get $q() { return this.registerContext.$q; }
        get $timeout() { return this.registerContext.$timeout; }
        get $rootScope() { return this.registerContext.$rootScope; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get busyService() { return this.registerContext.busyService; }
        get hostedPageService() { return this.registerContext.hostedPageService; }

        get creditCardProcessingEnabled() {
            return this.registerContext.creditCardProcessingEnabled;
        }

        isHostedPageActive(hostedPageId: Meevo.Model.HostedPageIdType) {
            return this.hostedPageService.getHostedPageActive(hostedPageId);
        }

        protected returnToOptions() {
            const returnSection = this.registerContext.isCreditMode
                ? RegisterSectionTypeEnum.ChangeOptions
                : RegisterSectionTypeEnum.PaymentOptions;

            return this.registerContext.selectSection(returnSection);
        }

        protected getNewPayment(paymentCategory: Model.PaymentCategoryEnum = Model.PaymentCategoryEnum.CreditDebit): any {
            return {
                __type: "Millennium.Meevo.Register.Contracts.Model.SalePaymentCreditCard, Millennium.Meevo.Register.Contracts.Model",
                amount: 0,
                taxAmount: 0,
                isPending: this.creditCardProcessingEnabled || paymentCategory === Model.PaymentCategoryEnum.CareCredit,
                paymentCategory: paymentCategory,
                paymentRequestId: null,
                transactionSetupId: null,
                tempId: Guid.newGuid().toString(),
            };
        }

        protected getProcessedPaymentMessage(processedPayment): string {
            let message: string;
            if (processedPayment.creditCardProcessorStatus.message) {
                message = this.$translate.instant(processedPayment.creditCardProcessorStatus.message);
                if (message === processedPayment.creditCardProcessorStatus.message) {
                    message = this.$translate.instant("MESSAGE_CC_STATUS_UNKNOWN") + ` (${processedPayment.creditCardProcessorStatus.message})`;
                }
            } else {
                message = this.$translate.instant("MESSAGE_CC_STATUS_UNKNOWN");
            }
            message += this.registerContext.appendPaymentAlertMessage(processedPayment.creditCardProcessorStatus);
            if (processedPayment.creditCardProcessorStatus.processorMessage) {
                let processorDetailsHeading = this.$translate.instant('LABEL_PROCESSOR_DETAILS');
                // add translated heading and detail
                message = message + '<br/><b>' + processorDetailsHeading + ':</b> ' + processedPayment.creditCardProcessorStatus.processorMessage.replace("\n", "<br/>");
            }
            return message;
        }

        protected processPaymentErrorCallback(response) {
            this.registerContext.removePendingTicketPaymentLine();

            switch (response.status) {
                case 408: //timeout
                    this.busyService.stop();
                    return this.modalService.alert('MESSAGE_CC_STATUS_REQUESTTIMEOUT').finally(() => {
                        return this.returnToOptions();
                    });

                case 409: //conflict
                    this.busyService.stop();
                    return this.modalService.alert(response.data.responseStatus.message);
            }

            this.reset();
        };
    }
}
